export default __webpack_public_path__ + "static/media/artistaCallejero.27bc657f.jpg";